import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { DEFAULT_CURRENCY_CODE, getCurrencySymbol } from '@/utils/money';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { OverrideInput, Props as OverrideInputProps } from './override-input';
import { Text } from 'react-native';

type Props = Omit<OverrideInputProps, 'initialValue'> & {
  currencyCode?: string | null;
  inDraggableSheet?: boolean;
  isConfirming: boolean;
};

export const PriceOverrideInput: React.FC<Props> = ({
  currencyCode,
  onChange,
  ...rest
}) => {
  const [styles] = useStyles();

  return (
    <OverrideInput
      leftElement={
        <Text style={[TYPOGRAPHY.small, styles.inputLeftElementText]}>
          {getCurrencySymbol(currencyCode ?? DEFAULT_CURRENCY_CODE)}
        </Text>
      }
      onChange={onChange}
      {...rest}
    />
  );
};

const useStyles = createStyles((theme) => ({
  inputLeftElementText: {
    ...FONTS.primarySemiBold,
    color: theme.colors.inactiveText,
  },
}));
